/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Search_Disabled_WebsitesInputs */

const en_common_search_disabled_websites = /** @type {(inputs: Common_Search_Disabled_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search disabled websites...`)
};

const es_common_search_disabled_websites = /** @type {(inputs: Common_Search_Disabled_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar sitios deshabilitados...`)
};

/**
* | output |
* | --- |
* | "Search disabled websites..." |
*
* @param {Common_Search_Disabled_WebsitesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_search_disabled_websites = /** @type {((inputs?: Common_Search_Disabled_WebsitesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Search_Disabled_WebsitesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_search_disabled_websites(inputs)
	return en_common_search_disabled_websites(inputs)
});